/* ============================================================
   KOVARO — front-end micro-interactions (Dawn-kompatibel)
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll-Reveal für [data-kvr-reveal] */
  function initReveal() {
    var els = document.querySelectorAll('[data-kvr-reveal]:not(.kvr-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kvr-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('kvr-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(initReveal);

  /* Im Shopify-Theme-Editor: bei Section-Wechsel neu binden */
  document.addEventListener('shopify:section:load', initReveal);
})();
